import { z } from 'zod';

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().min(1).default('/api/v1'),
  VITE_APP_ENV: z.enum(['local', 'dev', 'staging', 'prod']).default('local'),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  throw new Error(`Invalid frontend environment configuration: ${z.prettifyError(parsed.error)}`);
}

export const env = parsed.data;
